// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
// import { LogOut, Menu, X } from "lucide-react";


// const CSS = `
// @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600&family=Outfit:wght@300;400;500;600;700&display=swap');

// *,*::before,*::after { box-sizing: border-box; margin: 0; padding: 0; }
// :root {
//   --g900:#0d2b12; --g800:#1a4520; --g700:#1f5c28;
//   --g600:#2e7d32; --g500:#388e3c; --g400:#4caf50;
//   --g200:#c8e6c9; --g100:#e8f5e9; --g50:#f4fbf4;
//   --wh:#fff; --ink:#0f1f11; --ink2:#2d3b2f;
//   --mut:#6b7c6d; --ln:#e4ede5; --sidebar:240px;
// }
// html,body { font-family:'Outfit',sans-serif; background:var(--g50); color:var(--ink); -webkit-font-smoothing:antialiased; }
// @keyframes fadeUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:none} }
// @keyframes fadeIn { from{opacity:0} to{opacity:1} }
// .fu { animation: fadeUp .4s cubic-bezier(.22,.68,0,1.1) both; }
// .fi { animation: fadeIn .3s ease both; }
// .d1{animation-delay:.05s}.d2{animation-delay:.1s}.d3{animation-delay:.15s}
// .d4{animation-delay:.2s}.d5{animation-delay:.25s}.d6{animation-delay:.3s}
// ::-webkit-scrollbar{width:5px}
// ::-webkit-scrollbar-thumb{background:var(--g200);border-radius:4px}

// .sidebar-overlay {
//   display:none; position:fixed; inset:0;
//   background:rgba(0,0,0,.45); z-index:199;
// }
// .sidebar-overlay.open { display:block; }

// .dash-sidebar {
//   width:var(--sidebar); flex-shrink:0;
//   background:var(--g900);
//   display:flex; flex-direction:column;
//   position:sticky; top:0; height:100vh;
//   z-index:100; transition:transform .3s ease;
// }

// .mobile-bottom-nav { display:none; }
// .hamburger-btn { display:none !important; }

// @media(max-width:767px) {
//   .dash-sidebar {
//     position:fixed; top:0; left:0;
//     height:100dvh;
//     transform:translateX(-100%);
//     z-index:200;
//   }
//   .dash-sidebar.mobile-open { transform:translateX(0); }

//   .hamburger-btn { display:flex !important; }

//   .page-content { padding:16px !important; padding-bottom:80px !important; }
//   .top-bar { padding:0 14px !important; }

//   .top-bar h1 { font-size:17px !important; }

//   .mobile-bottom-nav {
//     display:flex;
//     position:fixed; bottom:0; left:0; right:0;
//     background:var(--g900);
//     border-top:1px solid rgba(255,255,255,.08);
//     z-index:150; height:64px;
//     align-items:stretch;
//     /* Safe area for iOS */
//     padding-bottom:env(safe-area-inset-bottom);
//   }
//   .mobile-nav-btn {
//     flex:1; display:flex; flex-direction:column;
//     align-items:center; justify-content:center;
//     gap:3px; background:transparent; border:none;
//     cursor:pointer; color:rgba(255,255,255,.4);
//     font-family:'Outfit',sans-serif;
//     font-size:9.5px; font-weight:500;
//     padding:6px 2px; transition:color .2s;
//     -webkit-tap-highlight-color:transparent;
//   }
//   .mobile-nav-btn.active { color:#fff; }
// }
// `;

// export default function DashboardLayout({ children, role, title, navItems = [] }) {
//   const { logout, profile } = useAuth();
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const roleColors = {
//     super_admin: { accent: '#6a1b9a', light: '#f3e5f5', label: 'Super Admin' },
//     hoa_admin: { accent: '#1565c0', light: '#e3f2fd', label: 'HOA Admin' },
//     valet: { accent: '#e65100', light: '#fff3e0', label: 'Valet' },
//     resident: { accent: 'var(--g600)', light: 'var(--g100)', label: 'Resident' },
//   };
//   const rc = roleColors[role] || roleColors.resident;
//   const accentDot = rc.accent === 'var(--g600)' ? '#4caf50' : rc.accent;
//   const labelColor = rc.accent === 'var(--g600)' ? 'var(--g700)' : rc.accent;

//   const handleLogout = async () => { await logout(); navigate('/', { replace: true }); };

//   const NavList = () => (
//     <nav style={{ flex: 1, padding: '12px', overflowY: 'auto' }}>
//       {navItems.map((item, i) => {
//         const Icon = item.icon;
//         return (
//           <button key={i}
//             onClick={() => {
//               if (item.path) navigate(item.path);
//               item.onClick?.();
//               setMobileOpen(false);
//             }}
//             style={{
//               width: '100%', display: 'flex', alignItems: 'center', gap: 11,
//               padding: '10px 12px', borderRadius: 9,
//               background: item.active ? 'rgba(255,255,255,.1)' : 'transparent',
//               border: 'none', cursor: 'pointer',
//               color: item.active ? '#fff' : 'rgba(255,255,255,.5)',
//               fontSize: 13.5, fontWeight: item.active ? 600 : 400,
//               fontFamily: "'Outfit',sans-serif", marginBottom: 2,
//               transition: 'background .2s, color .2s', textAlign: 'left',
//             }}
//             onMouseEnter={e => { if (!item.active) { e.currentTarget.style.background = 'rgba(255,255,255,.06)'; e.currentTarget.style.color = 'rgba(255,255,255,.8)'; } }}
//             onMouseLeave={e => { if (!item.active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,.5)'; } }}
//           >
//             {Icon && <Icon size={16} strokeWidth={1.8} />}
//             {item.label}
//             {item.badge && (
//               <span style={{ marginLeft: 'auto', background: rc.accent, color: '#fff', fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 10 }}>
//                 {item.badge}
//               </span>
//             )}
//           </button>
//         );
//       })}
//     </nav>
//   );

//   return (
//     <>
//       <style>{CSS}</style>

//       {/* Overlay */}
//       <div className={`sidebar-overlay${mobileOpen ? ' open' : ''}`} onClick={() => setMobileOpen(false)} />

//       <div style={{ display: 'flex', minHeight: '100dvh' }}>

//         {/* ── Sidebar ── */}
//         <aside className={`dash-sidebar${mobileOpen ? ' mobile-open' : ''}`}>
//           {/* Logo + close btn */}
//           <div style={{ padding: '24px 20px 20px', borderBottom: '1px solid rgba(255,255,255,.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <div>
//               <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, fontWeight: 500, color: 'rgba(255,255,255,.95)', letterSpacing: '.4px' }}>Canluxa</div>
//               <div style={{ fontSize: 8.5, fontWeight: 700, letterSpacing: '1.8px', textTransform: 'uppercase', color: 'rgba(255,255,255,.3)', marginTop: 2 }}>Valet Trash</div>
//             </div>
//             <button className="hamburger-btn" onClick={() => setMobileOpen(false)}
//               style={{ background: 'rgba(255,255,255,.08)', border: 'none', borderRadius: 8, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'rgba(255,255,255,.6)' }}>
//               <X size={16} />
//             </button>
//           </div>

//           {/* Role badge */}
//           <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
//             <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: 'rgba(255,255,255,.08)', borderRadius: 8, padding: '6px 12px' }}>
//               <div style={{ width: 7, height: 7, borderRadius: '50%', background: accentDot }} />
//               <span style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,.7)' }}>{rc.label}</span>
//             </div>
//           </div>

//           <NavList />

//           {/* Logout */}
//           <div style={{ padding: '16px 12px', borderTop: '1px solid rgba(255,255,255,.08)' }}>
//             <div style={{ fontSize: 12, color: 'rgba(255,255,255,.3)', padding: '0 12px', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//               {profile?.email || profile?.code || ''}
//             </div>
//             <button onClick={handleLogout}
//               style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 9, background: 'transparent', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,.4)', fontSize: 13.5, fontFamily: "'Outfit',sans-serif", transition: 'background .2s, color .2s' }}
//               onMouseEnter={e => { e.currentTarget.style.background = 'rgba(239,83,80,.12)'; e.currentTarget.style.color = '#ef9a9a'; }}
//               onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,.4)'; }}
//             >
//               <LogOut size={15} strokeWidth={1.8} />
//               Sign Out
//             </button>
//           </div>
//         </aside>

//         {/* ── Main ── */}
//         <main style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
//           {/* Top bar */}
//           <header className="top-bar" style={{ background: 'var(--wh)', borderBottom: '1px solid var(--ln)', padding: '0 32px', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50 }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
//               <button className="hamburger-btn" onClick={() => setMobileOpen(true)}
//                 style={{ background: 'var(--g50)', border: '1px solid var(--ln)', borderRadius: 9, width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--ink)', flexShrink: 0 }}>
//                 <Menu size={18} />
//               </button>
//               <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, fontWeight: 500, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</h1>
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: rc.light, borderRadius: 8, padding: '5px 12px', flexShrink: 0 }}>
//               <div style={{ width: 6, height: 6, borderRadius: '50%', background: accentDot }} />
//               <span style={{ fontSize: 12, fontWeight: 600, color: labelColor }}>{rc.label}</span>
//             </div>
//           </header>

//           {/* Content */}
//           <div className="page-content" style={{ flex: 1, padding: '32px', overflowY: 'auto' }}>
//             {children}
//           </div>
//         </main>
//       </div>

//       {/* Mobile bottom nav */}
//       <nav className="mobile-bottom-nav">
//         {navItems.slice(0, 5).map((item, i) => {
//           const Icon = item.icon;
//           return (
//             <button key={i} className={`mobile-nav-btn${item.active ? ' active' : ''}`} onClick={() => item.onClick?.()}>
//               {Icon && <Icon size={20} strokeWidth={item.active ? 2.2 : 1.6} />}
//               <span>{item.label}</span>
//             </button>
//           );
//         })}
//       </nav>
//     </>
//   );
// }



import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { LogOut, Menu, X } from "lucide-react";


const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600&family=Outfit:wght@300;400;500;600;700&display=swap');

*,*::before,*::after { box-sizing: border-box; margin: 0; padding: 0; }
:root {
  --g900:#0d2b12; --g800:#1a4520; --g700:#1f5c28;
  --g600:#2e7d32; --g500:#388e3c; --g400:#4caf50;
  --g200:#c8e6c9; --g100:#e8f5e9; --g50:#f4fbf4;
  --wh:#fff; --ink:#0f1f11; --ink2:#2d3b2f;
  --mut:#6b7c6d; --ln:#e4ede5; --sidebar:240px;
}
html,body { font-family:'Outfit',sans-serif; background:var(--g50); color:var(--ink); -webkit-font-smoothing:antialiased; }
@keyframes fadeUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:none} }
@keyframes fadeIn { from{opacity:0} to{opacity:1} }
.fu { animation: fadeUp .4s cubic-bezier(.22,.68,0,1.1) both; }
.fi { animation: fadeIn .3s ease both; }
.d1{animation-delay:.05s}.d2{animation-delay:.1s}.d3{animation-delay:.15s}
.d4{animation-delay:.2s}.d5{animation-delay:.25s}.d6{animation-delay:.3s}
::-webkit-scrollbar{width:5px}
::-webkit-scrollbar-thumb{background:var(--g200);border-radius:4px}

.sidebar-overlay {
  display:none; position:fixed; inset:0;
  background:rgba(0,0,0,.45); z-index:199;
}
.sidebar-overlay.open { display:block; }

.dash-sidebar {
  width:var(--sidebar); flex-shrink:0;
  background:var(--g900);
  display:flex; flex-direction:column;
  position:sticky; top:0; height:100vh;
  z-index:100; transition:transform .3s ease;
}

.mobile-bottom-nav { display:none; }
.hamburger-btn { display:none !important; }

@media(max-width:767px) {
  .dash-sidebar {
    position:fixed; top:0; left:0;
    height:100dvh;
    transform:translateX(-100%);
    z-index:200;
  }
  .dash-sidebar.mobile-open { transform:translateX(0); }

  .hamburger-btn { display:flex !important; }

  .page-content { padding:16px !important; padding-bottom:80px !important; }
  .top-bar { padding:0 14px !important; }

  .top-bar h1 { font-size:17px !important; }

  .mobile-bottom-nav {
    display:flex;
    position:fixed; bottom:0; left:0; right:0;
    background:var(--g900);
    border-top:1px solid rgba(255,255,255,.08);
    z-index:150; height:64px;
    align-items:stretch;
    padding-bottom:env(safe-area-inset-bottom);
  }
  .mobile-nav-btn {
    flex:1; display:flex; flex-direction:column;
    align-items:center; justify-content:center;
    gap:3px; background:transparent; border:none;
    cursor:pointer; color:rgba(255,255,255,.4);
    font-family:'Outfit',sans-serif;
    font-size:9.5px; font-weight:500;
    padding:6px 2px; transition:color .2s;
    -webkit-tap-highlight-color:transparent;
  }
  .mobile-nav-btn.active { color:#fff; }
}
`;

export default function DashboardLayout({ children, role, title, navItems = [] }) {
  const { logout, profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const roleColors = {
    super_admin: { accent: '#6a1b9a', light: '#f3e5f5', label: 'Super Admin' },
    hoa_admin:   { accent: '#1565c0', light: '#e3f2fd', label: 'HOA Admin' },
    valet:       { accent: '#e65100', light: '#fff3e0', label: 'Valet' },
    resident:    { accent: 'var(--g600)', light: 'var(--g100)', label: 'Resident' },
  };
  const rc = roleColors[role] || roleColors.resident;
  const accentDot  = rc.accent === 'var(--g600)' ? '#4caf50' : rc.accent;
  const labelColor = rc.accent === 'var(--g600)' ? 'var(--g700)' : rc.accent;

  const handleLogout = async () => {
    await logout();
    navigate('/', { replace: true });
  };

  // ── Derive active state from current URL ──────────────────────────────────
  const enrichedNav = navItems.map(item => ({
    ...item,
    active: item.path ? location.pathname === item.path : false,
  }));

  // ── Shared nav item click handler ─────────────────────────────────────────
  const handleNavClick = (item) => {
    if (item.path) navigate(item.path);
    item.onClick?.();
    setMobileOpen(false);
  };

  // ── Sidebar nav list ──────────────────────────────────────────────────────
  const NavList = () => (
    <nav style={{ flex: 1, padding: '12px', overflowY: 'auto' }}>
      {enrichedNav.map((item, i) => {
        const Icon = item.icon;
        return (
          <button
            key={i}
            onClick={() => handleNavClick(item)}
            style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 11,
              padding: '10px 12px', borderRadius: 9,
              background: item.active ? 'rgba(255,255,255,.1)' : 'transparent',
              border: 'none', cursor: 'pointer',
              color: item.active ? '#fff' : 'rgba(255,255,255,.5)',
              fontSize: 13.5, fontWeight: item.active ? 600 : 400,
              fontFamily: "'Outfit',sans-serif", marginBottom: 2,
              transition: 'background .2s, color .2s', textAlign: 'left',
            }}
            onMouseEnter={e => {
              if (!item.active) {
                e.currentTarget.style.background = 'rgba(255,255,255,.06)';
                e.currentTarget.style.color = 'rgba(255,255,255,.8)';
              }
            }}
            onMouseLeave={e => {
              if (!item.active) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'rgba(255,255,255,.5)';
              }
            }}
          >
            {Icon && <Icon size={16} strokeWidth={1.8} />}
            {item.label}
            {item.badge && (
              <span style={{
                marginLeft: 'auto', background: rc.accent, color: '#fff',
                fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 10,
              }}>
                {item.badge}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );

  return (
    <>
      <style>{CSS}</style>

      {/* Overlay */}
      <div
        className={`sidebar-overlay${mobileOpen ? ' open' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      <div style={{ display: 'flex', minHeight: '100dvh' }}>

        {/* ── Sidebar ── */}
        <aside className={`dash-sidebar${mobileOpen ? ' mobile-open' : ''}`}>

          {/* Logo + close btn */}
          <div style={{
            padding: '24px 20px 20px',
            borderBottom: '1px solid rgba(255,255,255,.08)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div>
              <div style={{
                fontFamily: "'Playfair Display',serif", fontSize: 20,
                fontWeight: 500, color: 'rgba(255,255,255,.95)', letterSpacing: '.4px',
              }}>
                Canluxa
              </div>
              <div style={{
                fontSize: 8.5, fontWeight: 700, letterSpacing: '1.8px',
                textTransform: 'uppercase', color: 'rgba(255,255,255,.3)', marginTop: 2,
              }}>
                Valet Trash
              </div>
            </div>
            <button
              className="hamburger-btn"
              onClick={() => setMobileOpen(false)}
              style={{
                background: 'rgba(255,255,255,.08)', border: 'none', borderRadius: 8,
                width: 32, height: 32, display: 'flex', alignItems: 'center',
                justifyContent: 'center', cursor: 'pointer', color: 'rgba(255,255,255,.6)',
              }}
            >
              <X size={16} />
            </button>
          </div>

          {/* Role badge */}
          <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              background: 'rgba(255,255,255,.08)', borderRadius: 8, padding: '6px 12px',
            }}>
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: accentDot }} />
              <span style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,.7)' }}>
                {rc.label}
              </span>
            </div>
          </div>

          <NavList />

          {/* Logout */}
          <div style={{ padding: '16px 12px', borderTop: '1px solid rgba(255,255,255,.08)' }}>
            <div style={{
              fontSize: 12, color: 'rgba(255,255,255,.3)', padding: '0 12px',
              marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {profile?.email || profile?.code || ''}
            </div>
            <button
              onClick={handleLogout}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 9, background: 'transparent',
                border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,.4)',
                fontSize: 13.5, fontFamily: "'Outfit',sans-serif", transition: 'background .2s, color .2s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(239,83,80,.12)';
                e.currentTarget.style.color = '#ef9a9a';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'rgba(255,255,255,.4)';
              }}
            >
              <LogOut size={15} strokeWidth={1.8} />
              Sign Out
            </button>
          </div>
        </aside>

        {/* ── Main ── */}
        <main style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>

          {/* Top bar */}
          <header
            className="top-bar"
            style={{
              background: 'var(--wh)', borderBottom: '1px solid var(--ln)',
              padding: '0 32px', height: 60,
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              position: 'sticky', top: 0, zIndex: 50,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
              <button
                className="hamburger-btn"
                onClick={() => setMobileOpen(true)}
                style={{
                  background: 'var(--g50)', border: '1px solid var(--ln)', borderRadius: 9,
                  width: 38, height: 38, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', cursor: 'pointer', color: 'var(--ink)', flexShrink: 0,
                }}
              >
                <Menu size={18} />
              </button>
              <h1 style={{
                fontFamily: "'Playfair Display',serif", fontSize: 20, fontWeight: 500,
                color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>
                {title}
              </h1>
            </div>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 8,
              background: rc.light, borderRadius: 8, padding: '5px 12px', flexShrink: 0,
            }}>
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: accentDot }} />
              <span style={{ fontSize: 12, fontWeight: 600, color: labelColor }}>{rc.label}</span>
            </div>
          </header>

          {/* Content */}
          <div className="page-content" style={{ flex: 1, padding: '32px', overflowY: 'auto' }}>
            {children}
          </div>
        </main>
      </div>

      {/* ── Mobile bottom nav ── */}
      <nav className="mobile-bottom-nav">
        {enrichedNav.slice(0, 5).map((item, i) => {
          const Icon = item.icon;
          return (
            <button
              key={i}
              className={`mobile-nav-btn${item.active ? ' active' : ''}`}
              onClick={() => handleNavClick(item)}
            >
              {Icon && <Icon size={20} strokeWidth={item.active ? 2.2 : 1.6} />}
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
}